export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_05.5544c8d4.jpg";